<template>
  <div>
    <v-dialog
      v-model="confirmDelete"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Delete Bottling Record?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="doConfirmDelete(true)"
          >
            Yes, Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Bottling Record</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md10>
                  <v-text-field v-model="editedItem.labelApproval" label="Label Approval Number"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedItem.alc" label="Alcohol"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedItem.cases375ml" label="375ml Cases"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedItem.cases750ml" label="750ml Cases"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedItem.cases1500ml" label="1.5L Cases"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md10>
                  <v-text-field type="number" v-model.number="editedItem.bottles3L" label="3L Bottles"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar>
          <v-spacer></v-spacer>
          <v-toolbar-title>Bottling Records</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="row end-xs" @click="newBottlingRecordClicked">New Bottling Record</v-btn>
        </v-toolbar>
        <v-data-table
            :headers='headers'
            :items='bottlingItems'
            item-key='id'
            hide-actions
            class="elevation-1"
            >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.labelApproval }}</td>
                <td>{{ props.item.alc }}</td>
                <td>{{ props.item.cases375ml }}</td>
                <td>{{ props.item.cases750ml }}</td>
                <td>{{ props.item.cases1500ml }}</td>
                <td width=100px class="justify-end">
                  <v-icon
                    color="primary"
                    small
                    class="mr-2"
                    @click="editItem(props.index)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    color="alert"
                    small
                    @click="deleteItem(props.index)"
                  >
                    delete
                  </v-icon>
                </td>
              </tr>
            </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
 </template>

<script>
import axios from 'axios'
import moment from 'moment'
import myMixins from '../mixins/myMixins'
export default {
  props: ['wo'],
  data () {
    return {
      headers: [
        { text: 'Label Approval #', value: 'labelApproval' },
        { text: 'Alcohol', value: 'alc' },
        { text: '375ml Cases', value: 'cases375ml' },
        { text: '750ml Cases', value: 'cases750ml' },
        { text: '1.5L Cases', value: 'cases1500ml' },
        { text: 'Action', value: 'action' }
      ],
      menu: false,
      dialog: false,
      confirmDelete: false,
      editedItem: {},
      editedIndex: -1,
      slider: 20,
      localWO: {},
      bottlingItems: [{
        alc: 0,
        cases375ml: 0,
        cases750ml: 0,
        cases1500ml: 0,
        labelApproval: ''
      }]
    }
  },
  mixins: [myMixins],
  created () {
    // this creates a reference rather than a copy of any changes to bottlingItems is also reflected in the wo
    // so we have no reason to emit data back up to the parent wo, it already has the changes.

    // we will want to do an emit, however, to let the parent workorder that there have been changes so that they can
    // be saved
    this.bottlingItems = this.wo.Bottlings
  },
  methods: {
    generateBottlingReport () {

    },
    newBottlingRecordClicked () {
      this.bottlingItems.push({
        labelApproval: '',
        alc: null,
        cases375ml: null,
        cases750ml: null,
        cases1500ml: null
      })
      this.editItem(this.bottlingItems.length - 1)
      this.$emit('bottlingRecordsUpdated')
    },
    editItem (index) {
      this.editedIndex = index
      // we create a copy for editing so that if the user cancels, the initial changed values are preserved
      this.editedItem = JSON.parse(JSON.stringify(this.bottlingItems[index]))
      this.dialog = true
    },
    doConfirmDelete (doIt) {
      if (doIt) {
        this.bottlingItems.splice(this.editingIndex, 1)
        this.$emit('bottlingRecordsUpdated')
      }
      this.confirmDelete = false
    },
    deleteItem (index) {
      this.editedIndex = index
      this.confirmDelete = true
    },
    close () {
      this.dialog = false
      this.editedIndex = -1
    },
    save () {
      this.bottlingItems[this.editedIndex].labelApproval = this.editedItem.labelApproval
      this.bottlingItems[this.editedIndex].alc = this.editedItem.alc
      this.bottlingItems[this.editedIndex].cases375ml = this.editedItem.cases375ml
      this.bottlingItems[this.editedIndex].cases750ml = this.editedItem.cases750ml
      this.bottlingItems[this.editedIndex].cases1500ml = this.editedItem.cases1500ml
      this.dialog = false
      this.$emit('bottlingRecordsUpdated')
    }
  },
  computed: {
  }
}
</script>

<style>
</style>
